import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { useCommentStore } from '@/components/Comments/CommentContext';
import { GenericFailureModal } from '../GenericFailureModal/GenericFailureModal';

const FailureModal: FC = () => {
  const { clearErrors } = useCommentStore();

  const onClickHandler = () => {
    clearErrors();
  };

  return <GenericFailureModal onCancel={onClickHandler} />;
};

export default observer(FailureModal);
